module.exports = __webpack_public_path__ + "2024611:ed75de4ab11883afa87d/img/sol-logo-guys-we-fcked.0861a0b.png";